import { TransferRecordIdentityKeyValue } from './transfer-record-identity-key-value.dto';

export class TransferRecordIdentityKey {
	public TableName: string;
	public PrimaryKeys: TransferRecordIdentityKeyValue[];
}
